export default function FormCheckbox({
  label,
  value,
  options,
  description,
  onChange,
  required = false,
  error = false,
  ...params
}) {
  return (
    <fieldset className="FormInput" {...params}>
      <legend className="FormLabel">{label}</legend>
      <div className="Options">
        {options.map((option) => (
          <div className="OptionInput" onClick={() => onChange(option.value)}>
            <input
              id={option.value}
              type="checkbox"
              checked={option.value === value}
            />
            <label className="text-base" htmlFor={option.value}>
              {option.text}
            </label>
          </div>
        ))}
      </div>
      {description && <p className="FormDescription">{description}</p>}
    </fieldset>
  );
}
